import React, { useState, useEffect, useRef } from 'react';

const Header = () => {
  const [scrolled, setScrolled] = useState(false);
  const rafId = useRef(null);

  useEffect(() => {
    const handleScroll = () => {
      // Cancel any pending animation frame
      if (rafId.current) {
        cancelAnimationFrame(rafId.current);
      }
      
      // Use requestAnimationFrame for smooth updates
      rafId.current = requestAnimationFrame(() => {
        const isScrolled = window.scrollY > 0;
        setScrolled(isScrolled);
      });
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => {
      window.removeEventListener('scroll', handleScroll);
      if (rafId.current) {
        cancelAnimationFrame(rafId.current);
      }
    };
  }, []);

  return (
    <header className={`header-container ${scrolled ? "header-scrolled" : ""}`}>
      <div className="brand-logo">
        <img
          src="/images/icons/Onlylogo.svg"
          alt="GoToEcom"
          width={60}
          height={60}
          className="logo-image"
        />
      </div>
    </header>
  );
};

export default Header;

